import { Message } from '@arco-design/web-react'
import * as Apis from '~/service/imagex'
import { serviceQuality } from '@byted-vcloud/exp-lite-slardar'
import { imagexConfig } from 'UTILS'
import { SlardarEventType } from '~/constants'

export function getUrlByUri(uri: string) {
  return `${imagexConfig.domain}/${uri}~tplv-${imagexConfig.serviceId}-image.image`
}

export async function getActiveUrl(url: string): Promise<string> {
  const { TaskId } = await Apis.CreateImageAnimTask({ ImageURL: url })
  ;(window as any).jobs[url] = TaskId
  return new Promise((resolve) => {
    const timer = setInterval(async () => {
      //异常中断，消除timer
      if (!Object.keys((window as any).jobs).includes(url)) {
        clearInterval(timer)
        resolve('')
      }
      try {
        const res = await Apis.GetImageAnimTaskDetail({ TaskId })
        //正常中断，消除timer和任务id
        if (res.Status !== 0) {
          clearInterval(timer)
          delete (window as any).jobs[url]
          if (res.Status === 1 && res.ResultUri) {
            serviceQuality({
              taskType: SlardarEventType.AnimImageTask,
              success: true,
              customInfo: { url, res },
            })
            resolve(getUrlByUri(res.ResultUri))
          } else if (res.Status === 2 && res.ErrMsg && res.ErrMsg !== 'Killed') {
            Message.error(res.ErrMsg)
            serviceQuality({
              taskType: SlardarEventType.AnimImageTask,
              success: false,
              customInfo: { url, res },
            })
          }
        }
      } catch (e) {
        console.error(e)
      }
    }, 1000)
  })
}
